
export function calculate_alarm(data_list) {

    for (let i = data_list.length - 2; i >= 0; i--) {
        if ('alarm' in data_list[i]) {
            if (data_list[i]['alarm']['stock_rights'] === 4) {
                if (data_list[i + 1]['alarm'] !== undefined) {
                    data_list[i]['alarm']['stock_rights'] = data_list[i + 1]['alarm']['stock_rights']
                } else {
                    data_list[i]['alarm']['stock_rights'] = 'x'
                }
            }
            if (data_list[i]['alarm']['stock_rights_fund'] === 4) {
                if (data_list[i + 1]['alarm'] !== undefined) {
                    data_list[i]['alarm']['stock_rights_fund'] = data_list[i + 1]['alarm']['stock_rights_fund']
                } else {
                    data_list[i]['alarm']['stock_rights_fund'] = 'x'
                }
            }
            if (data_list[i]['alarm']['fund_fixed'] === 4) {
                if (data_list[i + 1]['alarm'] !== undefined) {
                    data_list[i]['alarm']['fund_fixed'] = data_list[i + 1]['alarm']['fund_fixed']
                } else {
                    data_list[i]['alarm']['fund_fixed'] = 'x'
                }
            }
            
            if (data_list[i]['alarm']['gold'] === 4) {
                if (data_list[i + 1]['alarm'] !== undefined) {
                    data_list[i]['alarm']['gold'] = data_list[i + 1]['alarm']['gold']
                } else {
                    data_list[i]['alarm']['gold'] = 'x'
                }
            }
        }
    }
    return data_list
}

// export function calculate_score(data_list) {
//     for (let i = 0; i < data_list.length; i++) {
//         let temp = {};
//         if (data_list[i].plp_range_numbers !== undefined) {
//             ['stock_rights', 'stock_rights_fund', 'fund_fixed'].forEach((stock) => {

//                 const totalStockNumbers = data_list[i].plp_range_numbers[stock].reduce((a, b) => a + b, 0)
//                 const weightForEachRange = data_list[i].plp_range_numbers[stock].map((number, index) => {
//                     if (index >= 6) {
//                         index += 1
//                     }
//                     return (number / totalStockNumbers) * 100 * (index - 6)
//                 })

//                 const sumWeights = weightForEachRange.reduce((a, b) => a + b, 0)
//                 const finalScore = Math.round(sumWeights / 15)
//                 temp[stock] = finalScore
//             })
//             data_list[i]['score'] = temp
//         }
//     }
//     return data_list
// }

export function calculate_ao(data_list) {
    let new_ao;

    for (let i = 0; i < (data_list.length); i++) {
        let j = i + 1

        if (data_list[i] && data_list[j]) {
            if (data_list[i]['ao'] < data_list[j]['ao']) {
                new_ao = 'قرمز'
            } else {
                new_ao = 'سبز'
            }

            data_list[i]['new_ao'] = new_ao
        }
    }
    return data_list
}

export function calculate_equal_weight_percent(data_list) {
    for (let i = 0; i < (data_list.length) - 1; i++) {
        let j = i + 1
        if (data_list[i]['types'] && data_list[j]['types']) {
            if (data_list[i]['types']['totalequel_weithed']) {
                if (data_list[j]['types']['totalequel_weithed']) {
                    data_list[i]['totalequel_weithed_percent'] = (
                        (
                            data_list[i]['types']['totalequel_weithed']['value'] - data_list[j]['types']['totalequel_weithed']['value']
                        ) / data_list[i]['types']['totalequel_weithed']['value']
                    ) * 100
                }
            }
        }
    }
    return data_list
}

export function calculate_percent(data_list) {
    for (let i = 0; i < data_list.length - 1; i++) {
        let j = i + 1

        if (data_list[i]['close']) {
            if (data_list[j]['close']) {
                data_list[i]['percent'] = ((data_list[i]['close'] - data_list[j]['close']) / data_list[i]['close']) * 100
            }
        }
    }
    return data_list
}